/* __next_internal_client_entry_do_not_use__ Hamburger auto */ import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import * as React from "react";
import styled, { css } from "styled-components";
var Container = styled.div.withConfig({
    componentId: "sc-528671fd-0"
})([
    "position:relative;min-width:20px;min-height:14px;-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);-webkit-transition:0.5s ease-in-out;-moz-transition:0.5s ease-in-out;-o-transition:0.5s ease-in-out;transition:0.5s ease-in-out;cursor:pointer;"
]);
var Span = styled.span.withConfig({
    componentId: "sc-528671fd-1"
})([
    "display:block;position:absolute;height:1px;width:100%;background:#333;",
    ";opacity:1;left:0;-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);-webkit-transition:0.25s ease-in-out;-moz-transition:0.25s ease-in-out;-o-transition:0.25s ease-in-out;transition:0.25s ease-in-out;"
], function(param) {
    var $color = param.$color;
    return $color ? css([
        "background:",
        ";"
    ], $color) : css([
        "background:",
        ";"
    ], Core.surface.default);
});
var One = styled(Span).withConfig({
    componentId: "sc-528671fd-2"
})([
    "top:0;",
    ";"
], function(props) {
    return props.$open ? css([
        "top:7px;width:0;left:50%;"
    ]) : "";
});
var Two = styled(Span).withConfig({
    componentId: "sc-528671fd-3"
})([
    "top:7px;",
    ";"
], function(param) {
    var $open = param.$open, $deg = param.$deg;
    return $open ? css([
        "-webkit-transform:rotate(",
        "deg);-moz-transform:rotate(",
        "deg);-o-transform:rotate(",
        "deg);transform:rotate(",
        "deg);background:white;"
    ], $deg, $deg, $deg, $deg) : "";
});
var Three = styled(Span).withConfig({
    componentId: "sc-528671fd-4"
})([
    "top:7px;",
    ";"
], function(param) {
    var $open = param.$open, $deg = param.$deg;
    return $open ? css([
        "-webkit-transform:rotate(-",
        "deg);-moz-transform:rotate(-",
        "deg);-o-transform:rotate(-",
        "deg);transform:rotate(-",
        "deg);background:white;"
    ], $deg, $deg, $deg, $deg) : "";
});
var Four = styled(Span).withConfig({
    componentId: "sc-528671fd-5"
})([
    "top:14px;",
    ";"
], function(props) {
    return props.$open ? css([
        "top:7px;width:0;left:50%;"
    ]) : "";
});
export var Hamburger = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    _inherits(Hamburger, _React_Component);
    function Hamburger() {
        _class_call_check(this, Hamburger);
        return _call_super(this, Hamburger, arguments);
    }
    var _proto = Hamburger.prototype;
    _proto.render = function render() {
        var _this_props = this.props, open = _this_props.open, deg = _this_props.deg, color = _this_props.color;
        return /*#__PURE__*/ _jsxs(Container, {
            "data-test-id": "mobile-menu",
            children: [
                /*#__PURE__*/ _jsx(One, {
                    $open: open,
                    $color: color
                }),
                /*#__PURE__*/ _jsx(Two, {
                    $open: open,
                    $deg: deg,
                    $color: color
                }),
                /*#__PURE__*/ _jsx(Three, {
                    $open: open,
                    $deg: deg,
                    $color: color
                }),
                /*#__PURE__*/ _jsx(Four, {
                    $open: open,
                    $color: color
                })
            ]
        });
    };
    return Hamburger;
}(React.Component);
Hamburger.defaultProps = {
    open: false,
    deg: 40
};
